<ng-container>
  @if (showSearchButton) {
  <div class="row g-3 justify-content-md-start justify-content-lg-start">
    <div class="col-12 col-md-3 pb-2">
      <button
        type="button"
        class="btn btn-secondary form-control"
        [attr.aria-label]="'SEARCH' | globalTranslate"
        (click)="onOpen()"
      >
        {{ "SEARCH" | globalTranslate }}
        <i class="fa fa-pencil">&nbsp;&nbsp;</i>
      </button>
    </div>
    <div class="col-12 col-md-2 pb-2">
      <button
        type="button"
        class="btn btn-primary form-control"
        (click)="onReset()"
        [attr.aria-label]="
          ('REMOVE' | globalTranslate) + ' ' + (keyword | globalTranslate)
        "
      >
        {{ "REMOVE" | globalTranslate }} {{ keyword | globalTranslate }}
        <i class="fa fa-times">&nbsp;&nbsp;</i>
      </button>
    </div>
  </div>
  } @if (showLebelInput) {
  <ng-content select="[search-field]"></ng-content>
  } @if (showSearch) {
  <div class="mb-3">
    <!-- First paragraph -->
    <ng-content select="[search-intro]"></ng-content>
    <section [formGroup]="searchGroup">
      <!-- Form contents -->
      <div>
        <ng-content select="[search-form]"></ng-content>
      </div>
      <!-- 2 CTA buttons -->
      <div class="row g-3 justify-content-start">
        <div class="col-sm-12 col-md-2 py-2">
          <button
            class="btn btn-secondary"
            (click)="onSearch()"
            [ngClass]="{ 'width-translate': increaseWidth() }"
            [disabled]="!searchGroup.valid"
            [attr.aria-label]="'SEARCH' | globalTranslate"
          >
            {{ "SEARCH" | globalTranslate }}&nbsp; <i class="fa fa-search"></i>
          </button>
        </div>
        @if (keyword != 'bank') {
        <div class="col-12 col-md-3 py-2 py-md-0 order-md-2">
          <button
            class="btn d-grid btn-primary"
            (click)="onClose()"
            [attr.aria-label]="'CLOSE' | globalTranslate"
          >
            {{ "CLOSE" | globalTranslate }}&nbsp; <i class="fa fa-times"></i>
          </button>
        </div>
        }
      </div>
    </section>
    <br />
    @if ((rows$ | async); as rows) {
    <section>
      <!-- Second paragraph only changes a keyword, the rest is the same for all components -->
      <!-- Table Desktop -->
      <div class="d-none d-lg-block">
        <ngx-datatable
          class="bootstrap table-hover"
          columnMode="force"
          rowHeight="auto"
          selectionType="single"
          [headerHeight]="50"
          [footerHeight]="50"
          limit="5"
          [columns]="columns"
          [rows]="rows"
          (select)="onRow($event, rows)"
          [messages]="{ emptyMessage: this.emptyMessage | globalTranslate }"
        >
          @for (col of columns; track col) {
          <ngx-datatable-column
            [name]="col.name | globalTranslate"
            [prop]="col.prop"
          >
          </ngx-datatable-column>
          } @if (selectColumn) {
          <ngx-datatable-column
            name="{{ 'SELECT' | globalTranslate }}"
            [attr.aria-label]="'SELECT' | globalTranslate"
          >
            <ng-template
              ngx-datatable-cell-template
              let-row="row"
              let-rowIndex="rowIndex"
            >
              <span>
                @if (!row.select) {
                <span
                  tabindex="0"
                  class="un-selected-circle"
                  role="img"
                  [attr.aria-label]="'select radio button unselected'"
                  ><img
                    src="assets/images/Icons/bank-company-unselected.svg"
                    alt="unselected"
                    aria-hidden="true"
                /></span>
                } @if (row.select) {
                <span
                  class="select-cirlce"
                  role="img"
                  [attr.aria-label]="'select radio button selected'"
                  ><img
                    src="assets/images/Icons/bank-company-selected.svg"
                    alt="selected"
                    aria-hidden="true"
                /></span>
                }
              </span>
            </ng-template>
          </ngx-datatable-column>
          }
        </ngx-datatable>
        <br />
        <div class="row ps-3">
          <button
            (click)="canFindClick($event, rows)"
            class="btn btn-primary-search col-md-3"
            [attr.aria-label]="'CANT_FIND_BANK' | globalTranslate"
          >
            {{ "CANT_FIND_BANK" | globalTranslate }}
            <img src="../../assets/images/close-icon.svg" alt="close-icon" />
          </button>
        </div>
      </div>
      <!-- Table Mobile -->
      <div class="nh-table-mobile d-lg-none">
        @for (content of rows; track content; let i = $index) {
        <div class="table-row mb-3 pb-3">
          @for (head of columns; track head) {
          <div>
            <div
              class="mobile-table-header"
              tabindex="0"
              [innerHtml]="head.name | sanitize"
            ></div>
            <hr tabindex="-1" />
            <div
              class="mobile-table-data"
              tabindex="0"
              [innerHTML]="
                content
                  | path: head.prop
                  | loader: head.pipe:head.args
                  | sanitize
              "
            ></div>
            <br tabindex="-1" />
          </div>
          } @if (!content.select) {
          <button
            class="btn btn-secondary btn-sm select-{{ i }} w-100"
            (click)="onRow({ selected: [content] }, rows)"
            aria-label="unselected"
          >
            {{ "SELECT" | globalTranslate }}
          </button>
          } @if (content.select) {
          <button
            class="btn btn-secondary select-{{ i }} w-100"
            aria-label="selected"
          >
            {{ "SELECTED" | globalTranslate }}
          </button>
          }
        </div>
        }
        <div class="row px-3">
          <button
            (click)="canFindClick($event, rows)"
            class="btn btn-primary-search w-100"
            [attr.aria-label]="'CANT_FIND_BANK' | globalTranslate"
          >
            {{ "CANT_FIND_BANK" | globalTranslate }}
            <img src="../../assets/images/close-icon.svg" alt="close-icon" />
          </button>
        </div>
      </div>
    </section>
    }
  </div>
  }
</ng-container>